import { Box, Typography } from '@mui/material';

const SectionLabel = ({ children }) => (
  <Box sx={{ gridColumn: 'span 12' }}>
    <Typography variant="caption" color="text.secondary" fontWeight={600}>
      {children}
    </Typography>
  </Box>
);

export default SectionLabel;